import { doc, setDoc, updateDoc, getDoc, getDocs, query, where, collection } from "firebase/firestore";
import { db } from "../firebase";

// Function to set a user as admin (call this manually for initial setup)
export const setUserRole = async (userIdOrEmail, role = "user") => {
  try {
    // normalize
    const input = String(userIdOrEmail || "").trim();
    if (!input) throw new Error("empty identifier");

    // 1) if looks like an email, try to find existing doc by email
    if (input.includes("@")) {
      const q = query(collection(db, "users"), where("email", "==", input));
      const snaps = await getDocs(q);
      if (!snaps.empty) {
        const docRef = snaps.docs[0].ref;
        await updateDoc(docRef, { role, updatedAt: new Date() });
        return true;
      }
      // if not found by email, continue to try by treating input as id below (will create doc)
    }

    // 2) try treat input as uid (document id)
    const userDocRef = doc(db, "users", input);
    const existing = await getDoc(userDocRef);
    if (existing.exists()) {
      await updateDoc(userDocRef, { role, updatedAt: new Date() });
      return true;
    }

    // 3) not found — create a doc (use input as id). Prefer creating with uid; creating with email is allowed but avoid duplicates.
    await setDoc(userDocRef, { role, updatedAt: new Date(), userId: input });
    return true;
  } catch (error) {
    console.error("❌ Error setting user role:", error);
    return false;
  }
};

// Function to check if user is admin
export const checkUserRole = async (userId) => {
  try {
    const userDocRef = doc(db, "users", userId);
    const userDoc = await getDoc(userDocRef);
    
    if (userDoc.exists()) {
      return userDoc.data().role || "user";
    }
    return "user";
  } catch (error) {
    console.error("Error checking user role:", error);
    return "user";
  }
};

// Available roles
export const USER_ROLES = {
  ADMIN: "admin",
  USER: "user",
  MODERATOR: "moderator", // if you want additional roles
  HOFDIENST: "hofdienst"
};

// Test function to verify user role (for debugging)
export const testUserRole = async (userId) => {
  try {
    const userDocRef = doc(db, "users", userId);
    const userDoc = await getDoc(userDocRef);
    
    if (userDoc.exists()) {
      const userData = userDoc.data();
      console.log("User data:", userData);
      console.log("User role:", userData.role);
      return userData.role;
    } else {
      console.log("User document does not exist");
      return null;
    }
  } catch (error) {
    console.error("Error testing user role:", error);
    return null;
  }
};

// Make test function available globally
window.testUserRole = testUserRole;
